import React from 'react'

import LogoProyecto from './../../UI/Logos/logo-proyecto.svg'
import LogoConstructora from './../../UI/Logos/logo-constructora.svg'

interface Props{
    isLoading: boolean,
    gettingProjectInfo: boolean,
    errorGettingProjectInfo: boolean,
    downloadingImagesInfo: boolean,
    errorDownloadingImages: boolean,
    handleHideWelcome: any
}

interface State{}

class LoadingScreen extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isLoading ? "loading-div fade-in":"loading-div fade-out"}>
                <div className='circle-rotation-container'>
                    <div className='circle-rotation'/> 
                </div> 
                <div className='loading-info-container'>
                    <div className={this.props.gettingProjectInfo ? "fade-in":"fade-out"}>{this.props.errorGettingProjectInfo ? "Error obteniendo información":"Obteniendo información"}</div>
                    <div className={this.props.downloadingImagesInfo ? "fade-in":"fade-out"}>{this.props.errorDownloadingImages ? "Error descargando Imágenes":"Descargando Imágenes"}</div>
                </div>
            </div>
        )
    }
}

export default LoadingScreen